var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFilterOff(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.162 8.271 4.923-5.982H2.389l4.975 5.982a.83.83 0 0 1 .155.465v5.363l2.436 1.186v-6.6c0-.156.103-.31.207-.414Zm6.84-6.188-5.7 6.859v7.375c0 .515-.518.825-.933.618L6.586 15.13c-.207-.103-.414-.309-.414-.618v-5.57l-5.7-6.859C.109 1.67.42 1 .99 1h15.494c.57 0 .88.619.518 1.083Z",
    fill: "#1C4566",
    fillRule: "nonzero",
    stroke: "#1C4566",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterOff);
export default __webpack_public_path__ + "static/media/icon_filter_off.4fae8efca934d5e73a0c84eff09cb9a2.svg";
export { ForwardRef as ReactComponent };